import { Navigate, RouteObject, useParams } from "react-router-dom";
import { createDevelopmentLotSchedulesUrl } from "src/RouteUrls";
import { TaskLookaheadPage } from "src/routes/developments/reports/task-lookahead/TaskLookaheadPage";
import { DevelopmentBulkSchedulePage } from "src/routes/developments/schedule/DevelopmentBulkSchedulePage";
import { DevelopmentSchedulePage } from "src/routes/developments/schedule/development-level-schedule/DevelopmentSchedulePage";
import * as schedulesPaths from "src/routing/domains/developments/schedules/schedulesPaths";

/**
 * SideNav leaf routes for development schedules section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentLegacySideNavLayout` in `detail/developmentDetail.tsx`.
 */
export const schedulesSideNavRoutes: RouteObject[] = [
  { path: schedulesPaths.developmentScheduleRoute.path, Component: DevelopmentSchedulePage },
  { path: schedulesPaths.developmentLotSchedulesRoute.path, Component: DevelopmentBulkSchedulePage },
  { path: schedulesPaths.developmentTaskLookaheadReportRoute.path, Component: TaskLookaheadPage },
  // Deprecating the ambiguous `/schedule` route now that we have lot-schedules + development-schedule.
  { path: schedulesPaths.developmentLegacyScheduleRoute.path, Component: RedirectLegacyScheduleToLotSchedules },
];

function RedirectLegacyScheduleToLotSchedules() {
  const { developmentId } = useParams<{ developmentId: string }>();
  return <Navigate to={createDevelopmentLotSchedulesUrl(developmentId!)} replace />;
}
